// ---------------------------------------------------------------
// maskEmail.js — Oculta el correo al mostrarlo por pantalla.
// Deja visibles la primera y la última letra del nombre y el
// dominio entero, para que quien lo lee reconozca su cuenta sin
// que nadie más pueda apuntársela:
//   brundindev@gmail.com  ->  b********v@gmail.com
//   ana@farmacia.es       ->  a**a@farmacia.es
//   jo@hotmail.com        ->  j*o@hotmail.com
//   j@hotmail.com         ->  j***@hotmail.com
// ---------------------------------------------------------------

export function maskEmail(email) {
  if (typeof email !== "string") return "";
  const at = email.lastIndexOf("@");
  // Si no parece un correo, no inventamos nada: lo ocultamos entero
  if (at <= 0) return email ? "•".repeat(Math.min(email.length, 8)) : "";

  const nombre = email.slice(0, at);
  const dominio = email.slice(at); // incluye la "@" y la extensión

  // Con una sola letra no hay "última" que enseñar sin destaparlo todo
  if (nombre.length === 1) return `${nombre}***${dominio}`;

  const primera = nombre[0];
  const ultima = nombre[nombre.length - 1];
  const ocultas = Math.max(nombre.length - 2, 1);
  return `${primera}${"*".repeat(ocultas)}${ultima}${dominio}`;
}

export default maskEmail;
